import { Card, ChannelIcon, Flex, Text } from '@buffer-mono/popcorn'

import { graphql } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

import styles from './GbpMockPostCard.module.css'

import type { JSX } from 'react'

export const GbpMockPostCard_Channel = graphql(`
  fragment GbpMockPostCard_Channel on Channel @_unmask {
    name
    displayName
  }
`)

type GbpMockPostCardProps = {
  channel: FragmentOf<typeof GbpMockPostCard_Channel>
  subtitle?: string | null
}

/**
 * A simplified post card for Google Business Profile reviews.
 * Since GBP reviews come from the business listing (not a Buffer post),
 * we display channel information instead of post content.
 */
export function GbpMockPostCard({
  channel,
  subtitle,
}: GbpMockPostCardProps): JSX.Element {
  return (
    <Card
      padding="none"
      className={styles.card}
      aria-label="Google Business Profile listing"
    >
      <Flex direction="column" gap="xs">
        <Flex align="center" gap="xs">
          <span className={styles.channelIcon}>
            <ChannelIcon type="googlebusiness" size={12} />
          </span>
          <Text size="sm" weight="medium" color="subtle" translate="no">
            {channel.displayName ?? channel.name}
          </Text>
        </Flex>
        {subtitle ? (
          <em>
            <Text color="subtle">{subtitle}</Text>
          </em>
        ) : null}
      </Flex>
    </Card>
  )
}
